import { RRHeaderTabOptionModel } from './header-tab-option.model';
import { RRHeaderTabModel } from './header-tab.model';

export class RRHeaderModel {
  title: string;
  homeLink: string;
  logoUrl?: string;
  tabs: RRHeaderTabModel[];
  profile: RRHeaderTabOptionModel;
  hideDarkMode?: boolean;
  disabledReset?: boolean;
  showDocumentation?: boolean;
}
